import React, { useEffect, useState, useRef, useCallback } from 'react';
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate, useParams } from 'react-router-dom'
import { SuccessfullyModal } from '../../components/Modals/Modals';
import { getApi, postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import LocationPicker from '../../components/Map/LocationPicker';
import img2 from '../../assest/loading1.gif'

import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";

const CreateProductOrder = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false);
    const [category, setCategory] = useState([])
    const [subcategory, setSubCategory] = useState([])
    const [subcategorychild, setSubCategoryChild] = useState([])
    const [products, setProducts] = useState([])
    const [outfit, setOutfit] = useState([])
    const [cartcount, setCartCount] = useState(null)
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [loading4, setLoading4] = useState(false);
    const [loading5, setLoading5] = useState(false);
    const [loading6, setLoading6] = useState(false);

    const [formData, setFormData] = useState({
        outfits: [],
        equipment: [],
        contactName: '',
        phone: '',
        mobility: [],
        description: '',
        pinCode: '',
        parkingAccess: '',
        name: '',
        address: '',
        country: '',
        state: '',
        city: '',
        invoiceName: '',
        invoiceAddress: '',
        invoicePinCode: '',
        invoiceCity: '',
        invoiceCountry: '',
        companyRegistrationNumber: '',
        invoiceDetails: '',
        location: {
            type: "Point",
            coordinates: [],
        },
    });

    const defaultJob = {
        category: '',
        subCategory: '',
        subCategoryTimeId: '',
        date: '',
        toTime: '',
        fromTime: '',
        workingHours: 0,
        totalMin: 0,
        totalTime: '',
        price: 0,
        productId: '',
        quantity: 0,
        kids: 0,
        adults: 0,
    };


    const [jobInputs, setJobInputs] = useState(defaultJob);




    const fetchStaffData = useCallback(async () => {
        await getApi(endPoints.getStaffbyid(id), {
            setResponse: (response) => {
                const data = response?.data || {};
                setFormData({
                    name: `${data.firstName} ${data.lastName}` || '',
                    contactName: `${data.firstName} ${data.lastName}` || '',
                    invoiceName: `${data.firstName} ${data.lastName}` || '',
                    phone: data.phone || '',
                    address: data.addressOnPanCard || '',
                    invoiceAddress: data.addressOnPanCard || ''
                });
            },
            setLoading: setLoading5,
            errorMsg: 'Failed to fetch data!',
        });
    }, [id]);

    useEffect(() => {
        fetchStaffData();
    }, [fetchStaffData]);


    const handleJobChange = (e) => {
        const { name, value } = e.target;

        setJobInputs((prevJob) => {
            let updatedJob = { ...prevJob, [name]: value };

            // Handle subCategoryTimeId selection
            if (name === "subCategoryTimeId") {
                const selectedSubCategory = subcategorychild?.data?.find(
                    (cat) => cat._id === value
                );
                if (selectedSubCategory) {
                    updatedJob.totalMin = selectedSubCategory.totalMin;
                    updatedJob.totalTime = selectedSubCategory.totalTime;
                    updatedJob.price = selectedSubCategory.price;
                    updatedJob.workingHours = selectedSubCategory.totalMin / 60;

                    // If fromTime is already selected, auto-calculate toTime
                    if (prevJob.fromTime) {
                        const fromTime = new Date(prevJob.fromTime);
                        const toTime = new Date(fromTime.getTime() + selectedSubCategory.totalMin * 60000);
                        updatedJob.toTime = toTime.toISOString();
                    }
                }
            }

            if (name === "fromTime") {
                const today = new Date().toISOString().split("T")[0];
                const updatedFromTime = new Date(`${today}T${value}:00.000Z`);
                updatedJob.fromTime = updatedFromTime.toISOString();

                // If totalMin is already selected, auto-calculate toTime
                if (prevJob.totalMin) {
                    const toTime = new Date(updatedFromTime.getTime() + prevJob.totalMin * 60000);
                    updatedJob.toTime = toTime.toISOString();
                }
            }

            return updatedJob;
        });
    };





    const handleChange = (e) => {
        if (Array.isArray(e)) {
            // Handling MultiSelect
            setFormData((prev) => ({ ...prev, outfits: e.map(item => item.value) }));
        } else {
            const { name, value } = e.target;
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };


    const handleLocationSelect = (latLng) => {
        setFormData((prev) => ({
            ...prev,
            location: {
                type: "Point",
                coordinates: [latLng.lng, latLng.lat], // Store longitude, latitude
            },
        }));
    };

    const handleAddCart = async () => {
        const jobPayload = { ...jobInputs };
        await postApi(endPoints.addOrder(id), jobPayload, {
            successMsg: 'Item successfully added to cart!',
            errorMsg: 'Unable to add item to cart. Please try again.',
            setLoading: setLoading6,
            additionalFunctions: [
                () => setCartCount(prev => prev + 1),
                () => setJobInputs(defaultJob)
            ],
        });
    };


    const handleSubmit = async () => {
        const orderPayload = { ...formData };
        await postApi(endPoints.addOrder1(id), orderPayload, {
            successMsg: 'Order created successfully!',
            errorMsg: 'Failed to add jobs!',
            setLoading: setLoading,
            additionalFunctions: [
                () => {
                    setShow(true);
                    setFormData({})
                    setTimeout(() => {
                        setShow(false);
                        navigate(`/user-management/create-order/cart/${id}`);
                    }, 2000);
                },
            ],
        });
    };





    const fetchData = async () => {
        await getApi(endPoints.getallcategory, {
            setResponse: setCategory,
            setLoading: setLoading1,
            // errorMsg: 'Failed to fetch jobs!'
        });
    };

    const fetchSubCategoryData = async () => {
        await getApi(endPoints.getallsubcategorybycategory(jobInputs.category), {
            setResponse: setSubCategory,
            setLoading: setLoading2,
            // errorMsg: 'Failed to fetch jobs!'
        });
    };
    const fetchSubCategoryChildData = async () => {
        await getApi(endPoints.getallsubcategorychildbycategory(jobInputs.category, jobInputs.subCategory), {
            setResponse: setSubCategoryChild,
            setLoading: setLoading3,
            // errorMsg: 'Failed to fetch jobs!'
        });
    };

    const fetchProductData = async () => {
        await getApi(endPoints.getallproducts, {
            setResponse: setProducts,
            setLoading: setLoading6,
            // errorMsg: 'Failed to fetch jobs!'
        });
    };


    useEffect(() => {
        fetchData();
        fetchOutfitData();
        fetchProductData();
    }, []);

    useEffect(() => {
        if (jobInputs.category) {
            fetchSubCategoryData();
        }
    }, [jobInputs.category]);

    useEffect(() => {
        if (jobInputs.category && jobInputs.subCategory) {
            fetchSubCategoryChildData();
        }
    }, [jobInputs.category, jobInputs.subCategory]);





    const equipmentOptions = [
        { value: 'BOTTLE OPENER', label: 'BOTTLE OPENER' },
        { value: 'TOOLBOX', label: 'TOOLBOX' },
        { value: 'EQUIPMENT', label: 'EQUIPMENT' },
    ];

    const mobilityOptions = [
        { value: 'This Job Requires a Driving License', label: 'Driving License Required' },
        { value: 'The Professionals will have to use their own Vehicle', label: 'Own Vehicle Required' },
        { value: 'This Job Requires a Bar License', label: 'Bar License Required' },
    ];


    const fetchOutfitData = async () => {
        await getApi(endPoints.getalldress1, {
            setResponse: setOutfit,
            setLoading: setLoading4,
            // errorMsg: 'Failed to fetch jobs!'
        });
    };



    const MultiSelectCheckbox = ({
        options,
        selectedValues,
        onSelect,
        onRemove,
        placeholder,
        searchable = false
    }) => {
        const [isOpen, setIsOpen] = useState(false);
        const [tempSelections, setTempSelections] = useState([]);
        const [searchTerm, setSearchTerm] = useState("");
        const wrapperRef = useRef(null);

        useEffect(() => {
            if (isOpen) {
                setTempSelections(selectedValues || []);
            }
        }, [isOpen]);

        const filteredOptions = searchable
            ? options?.filter(option =>
                (option.label || option.name || "").toLowerCase().includes(searchTerm.toLowerCase())
            )
            : options;

        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        useEffect(() => {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }, []);

        const handleTempSelect = (value) => {
            setTempSelections(prev =>
                prev.includes(value)
                    ? prev.filter(v => v !== value)
                    : [...prev, value]
            );
        };

        const applySelections = () => {
            const toAdd = tempSelections.filter(v => !(selectedValues || []).includes(v));
            const toRemove = (selectedValues || []).filter(v => !tempSelections.includes(v));

            toAdd.forEach(value => onSelect(value));
            toRemove.forEach(value => onRemove(value));

            setIsOpen(false);
        };

        const cancelSelections = () => {
            setTempSelections(selectedValues || []);
            setIsOpen(false);
        };

        const toggleSelectAll = () => {
            if (tempSelections.length === filteredOptions.length) {
                setTempSelections([]);
            } else {
                setTempSelections(filteredOptions.map(opt => opt.value || opt.name));
            }
        };

        return (
            <div className={addjob.multiSelectWrapper} ref={wrapperRef}>
                <div className={addjob.selectInput} onClick={() => setIsOpen(!isOpen)}>
                    {placeholder}
                    <span className={addjob.arrowIcon}>{isOpen ? <IoIosArrowUp size={20} /> : <IoIosArrowDown size={20} />}</span>
                </div>

                {isOpen && (
                    <div className={addjob.dropdown}>
                        {searchable && (
                            <div className={addjob.searchBox}>
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        )}

                        <div className={addjob.selectAllContainer}>
                            <button
                                type="button"
                                onClick={toggleSelectAll}
                                className={addjob.selectAllButton}
                            >
                                {tempSelections.length === filteredOptions.length ? 'Deselect All' : 'Select All'}
                            </button>
                        </div>

                        <div className={addjob.optionsContainer}>
                            {filteredOptions.map(option => (
                                <h6 key={option.value || option.name} className={addjob.optionItem}>
                                    <input
                                        type="checkbox"
                                        checked={tempSelections.includes(option.value || option.name)}
                                        onChange={() => handleTempSelect(option.value || option.name)}
                                    />
                                    {option.label || option.name}
                                </h6>
                            ))}
                        </div>

                        <div className={addjob.dropdownFooter}>
                            <button type="button" className={addjob.cancelButton} onClick={cancelSelections}>
                                Cancel
                            </button>
                            <button type="button" className={addjob.applyButton} onClick={applySelections}>
                                Apply ({tempSelections.length})
                            </button>
                        </div>
                    </div>
                )}

                <div className={addjob.selectedTags}>
                    {(selectedValues || []).map((value) => {
                        const option = options.find(opt => opt.value === value || opt.name === value);
                        return (
                            <div key={value} className={addjob.tag}>
                                <span>{option?.label || option?.name}</span>
                                <button
                                    type="button"
                                    className={addjob.removeBtn}
                                    onClick={() => onRemove(value)}
                                >
                                    ×
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };





    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Successfully Added"}
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Create Order</h6>
                    </div>
                </div>
                {loading5 ? (
                    <div className={addjob.loadingnormal}>
                        <img src={img2} alt="Loading" width={100} height={100} />
                    </div>
                ) : (
                    <div className={addjob.addjobcontainer}>
                        <div className={addjob.addjobsubcontainer}>
                            <div className={addjob.addjobtopic}>
                                <h6>Add Order Details</h6>
                            </div>

                            <div className={addjob.addcontactdetails}>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="category">Select Category</label>
                                    <select
                                        name="category"
                                        value={jobInputs.category}
                                        onChange={handleJobChange}
                                    >
                                        <option value="">Select Category</option>
                                        {loading1 ?
                                            <option value="">Loading...</option>
                                            :
                                            category?.data?.length === 0 ?
                                                <option value="">No data</option>
                                                :
                                                category?.data?.map((cat) => (
                                                    <option key={cat._id} value={cat._id}>
                                                        {cat.name}
                                                    </option>
                                                ))}
                                    </select>
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Select Subcategory</label>
                                    <select
                                        name="subCategory"
                                        value={jobInputs.subCategory}
                                        onChange={handleJobChange}
                                    >
                                        <option value="">Select SubCategory</option>
                                        {loading2 ?
                                            <option value="">Loading...</option>
                                            :
                                            subcategory?.data?.length === 0 ?
                                                <option value="">No data</option>
                                                :
                                                subcategory?.data?.map((cat) => (
                                                    <option key={cat._id} value={cat._id}>
                                                        {cat.name}
                                                    </option>
                                                ))}
                                    </select>
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Select Product</label>
                                    <select
                                        name="productId"
                                        value={jobInputs.productId}
                                        onChange={handleJobChange}
                                    >
                                        <option value="">Select Product</option>
                                        {loading6 ?
                                            <option value="">Loading...</option>
                                            :
                                            products?.data?.length === 0 ?
                                                <option value="">No data</option>
                                                :
                                                products?.data?.map((cat) => (
                                                    <option key={cat._id} value={cat._id}>
                                                        {cat.name}
                                                    </option>
                                                ))}
                                    </select>
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="job-date">Date</label>
                                    <input
                                        type="date"
                                        name="date"
                                        value={jobInputs.date}
                                        min={new Date().toISOString().split('T')[0]}
                                        onChange={handleJobChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="job-time">Working Hours</label>
                                    <select
                                        name="subCategoryTimeId"
                                        value={jobInputs.subCategoryTimeId}
                                        onChange={handleJobChange}
                                    >
                                        <option value="">Select Hours</option>
                                        {loading3 ? (
                                            <option value="">Loading...</option>
                                        ) : subcategorychild?.data?.length === 0 ? (
                                            <option value="">No data</option>
                                        ) : (
                                            subcategorychild?.data?.map((cat) => (
                                                <option key={cat._id} value={cat._id}>
                                                    {cat.totalTime}
                                                </option>
                                            ))
                                        )}
                                    </select>
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="fromTime">Start Time</label>
                                    <input
                                        type="time"
                                        name="fromTime"
                                        value={jobInputs.fromTime?.split("T")[1]?.slice(0, 5) || ""}
                                        onChange={handleJobChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="toTime">End Time</label>
                                    <input
                                        type="time"
                                        name="toTime"
                                        value={jobInputs.toTime?.split("T")[1]?.slice(0, 5) || ""}
                                        readOnly
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="pax">Quantity</label>
                                    <input
                                        type="number"
                                        placeholder="Enter the quantity"
                                        name="quantity"
                                        value={jobInputs.quantity}
                                        onChange={handleJobChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="pax">Number of kids?</label>
                                    <input
                                        type="number"
                                        placeholder="Enter the total kids"
                                        name="kids"
                                        value={jobInputs.kids}
                                        onChange={handleJobChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="pax">Number of Adults?</label>
                                    <input
                                        type="number"
                                        placeholder="Enter the adults"
                                        name="adults"
                                        value={jobInputs.adults}
                                        onChange={handleJobChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="btn"> Click "Add" button to add to Cart</label>
                                    <div className={addjob.rightbuttons}>
                                        <button
                                            onClick={handleAddCart}
                                            style={{ background: '#F05423' }}
                                            disabled={loading6}
                                        >
                                            {loading6 ? "Adding..." : "Add"}
                                            <span style={{ marginLeft: "5px" }}>({cartcount})</span>
                                        </button>
                                    </div>
                                </div>


                            </div>
                            <div className={addjob.addjobtopic}>
                                <h6>Add Other Details</h6>
                            </div>
                            <div className={addjob.addcontactdetails}>

                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Select Outfit</label>
                                    <MultiSelectCheckbox
                                        options={outfit.data}
                                        selectedValues={formData.outfits}
                                        onSelect={(value) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                outfits: [...(prev.outfits || []), value]
                                            }))
                                        }
                                        onRemove={(value) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                outfits: prev.outfits.filter(v => v !== value)
                                            }))
                                        }
                                        placeholder="Select outfits..."
                                        searchable
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Select Equipment</label>
                                    <MultiSelectCheckbox
                                        options={equipmentOptions}
                                        selectedValues={formData.equipment}
                                        onSelect={(value) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                equipment: [...(prev.equipment || []), value]
                                            }))
                                        }
                                        onRemove={(value) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                equipment: prev.equipment.filter(v => v !== value)
                                            }))
                                        }
                                        placeholder="Select equipment..."
                                        searchable
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Select Mobility</label>
                                    <MultiSelectCheckbox
                                        options={mobilityOptions}
                                        selectedValues={formData.mobility}
                                        onSelect={(value) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                mobility: [...(prev.mobility || []), value]
                                            }))
                                        }
                                        onRemove={(value) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                mobility: prev.mobility.filter(v => v !== value)
                                            }))
                                        }
                                        placeholder="Select mobility requirements..."
                                        searchable
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Contact Name</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the contact name'
                                        name="contactName"
                                        value={formData.contactName}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Contact Phone</label>
                                    <input
                                        type="number"
                                        placeholder='Enter the contact number'
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Parking Access</label>
                                    <select value={formData.parkingAccess}
                                        name="parkingAccess"
                                        onChange={handleChange} >
                                        <option value="">Select</option>
                                        <option value="Free Parking">Free Parking</option>
                                        <option value="Paid Parking">Paid Parking</option>
                                    </select>
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Name</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the name'
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Address</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the address'
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Country</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the country'
                                        name="country"
                                        value={formData.country}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">State</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the state'
                                        name="state"
                                        value={formData.state}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">City</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the city'
                                        name="city"
                                        value={formData.city}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">PinCode</label>
                                    <input
                                        type="number"
                                        placeholder='Enter the pincode'
                                        name="pinCode"
                                        value={formData.pinCode}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className={addjob.addjobinputs}>
                                <label htmlFor="">Order Description</label>
                                <textarea placeholder='description'
                                    value={formData.description}
                                    name="description"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className={addjob.addjobtopic}>
                                <h6>Add Invoice Details</h6>
                            </div>
                            <div className={addjob.addcontactdetails}>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Invoice Name</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the invoice name'
                                        name="invoiceName"
                                        value={formData.invoiceName}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Invoice Address</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the invoice address'
                                        name="invoiceAddress"
                                        value={formData.invoiceAddress}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Invoice PinCode</label>
                                    <input
                                        type="number"
                                        placeholder='Enter the invoice pinCode'
                                        name="invoicePinCode"
                                        value={formData.invoicePinCode}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Invoice City</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the invoice city'
                                        name="invoiceCity"
                                        value={formData.invoiceCity}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Invoice Country</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the invoice country'
                                        name="invoiceCountry"
                                        value={formData.invoiceCountry}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Company Registration Number</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the company registration number'
                                        name="companyRegistrationNumber"
                                        value={formData.companyRegistrationNumber}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className={addjob.addjobinputs}>
                                <label htmlFor="">Invoice Details</label>
                                <textarea placeholder='description'
                                    value={formData.invoiceDetails}
                                    name="invoiceDetails"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className={addjob.addjobtopic}>
                                <h6>Select location from map</h6>
                            </div>
                            <div className={addjob.addjobinputs}>
                                <label htmlFor="">Map</label>
                                <LocationPicker onLocationSelect={handleLocationSelect} />
                            </div>
                        </div>
                        <div className={addjob.addjobbutton}>
                            <div className={addjob.rightbuttons}>
                                <button onClick={() => navigate(-1)}>Cancel</button>
                            </div>
                            <div className={addjob.rightbuttons}>
                                <button
                                    onClick={handleSubmit}
                                    style={{ background: '#F05423' }}
                                    disabled={loading}
                                >
                                    {loading ? "Adding..." : "Add"}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default HOC(CreateProductOrder)